// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form__Form___2quEe"};